import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import UserTemplate from './user';
import CompanyTemplate from './company';
import ControlLog from './ControlLog';
import { XTabNav } from '@/components/xqxc_ui';
import { getSessionStorage, removeSessionStorage } from '@/assets/js/storage';

const tabList = [
    { id: '1', label: '用户模板' },
    { id: '2', label: '企业模板' },
    { id: '3', label: '运费调控记录' },
];

const OCTabList = [
    { id: '2', label: '企业模板' },
    { id: '3', label: '运费调控记录' },
]

const ShippingFeeSet = (props) => {
    const { history, match, location } = props;
    const tabId = match.params && match.params.tabId || (process.env.TYPE == 'OC' ? 2 : 1);
    

    // const [curTabID, setCurTabID] = useState(1);

    useEffect(() => {
        if (getSessionStorage('systemShippingFeeSetCurTabID')) {
            // setCurTabID(getSessionStorage('systemShippingFeeSetCurTabID'));
            removeSessionStorage('systemShippingFeeSetCurTabID');
        }
    }, []);

    const onTabChange = (e)=>{
        let id = e.target.id;
        history.push(`/home/system/shippingfeeset/tab${id}`);
    };

    return <div className={styles.flexBoxContainer}>
        <div className={styles.tabBox}>
            {process.env.TYPE == 'OC' ? OCTabList.map(v=>{
                return (
                    <div className={`${styles.li} ${tabId == v.id ? styles.active : ''}`} key={v.id} id={v.id} onClick={onTabChange}>{v.label}</div>
                );
            }) : tabList.map(v=>{
                return (
                    <div className={`${styles.li} ${tabId == v.id ? styles.active : ''}`} key={v.id} id={v.id} onClick={onTabChange}>{v.label}</div>
                );
            })}
            <div className={styles.underLine} style={{left: (tabId - (process.env.TYPE == 'OC' ? 2 : 1)) * 120+'px'}}></div>
        </div>
        {tabId == 1 ? <UserTemplate history={history} match={match} curTabID='1' /> : null}
        {tabId == 2 ? <CompanyTemplate history={history} match={match} curTabID='2' /> : null}
        {tabId == 3 ? <ControlLog history={history} location={location} match={match} curTabID='3' /> : null}
    </div>;
};

ShippingFeeSet.propTypes = {
    history: PropTypes.object, // 路由
    match: PropTypes.object, // 路由match对象
    location: PropTypes.object, 
};

export default ShippingFeeSet;